import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Play } from 'lucide-react';

export const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center" data-testid="hero-section">
      {/* Video Background */}
      <div className="absolute inset-0 overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto -translate-x-1/2 -translate-y-1/2 object-cover"
          data-testid="hero-video"
        >
          <source 
            src="https://customer-assets.emergentagent.com/job_c6dd2c5d-713b-4be1-a54c-9cd952554724/artifacts/f21udztj_Episode%202%20Bicenter%20Consulting.mp4" 
            type="video/mp4" 
          />
        </video>
        {/* Overlay */}
        <div className="absolute inset-0 video-overlay" />
      </div>

      {/* Content */}
      <div className="relative z-10 container-custom pt-24">
        <div className="max-w-3xl">
          {/* Tagline */}
          <p 
            className="text-[#4caf50] font-medium text-sm md:text-base uppercase tracking-widest mb-4 animate-fade-in-up opacity-0"
            style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}
          >
            {t('hero.tagline')}
          </p>

          {/* Main Title */}
          <h1 
            className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-6 animate-fade-in-up opacity-0"
            style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
            data-testid="hero-title"
          >
            {t('hero.title')}
          </h1>

          {/* Subtitle */}
          <p 
            className="text-white/90 text-lg md:text-xl leading-relaxed mb-10 max-w-2xl animate-fade-in-up opacity-0"
            style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}
          >
            {t('hero.subtitle')}
          </p>

          {/* CTA Buttons */}
          <div 
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up opacity-0"
            style={{ animationDelay: '0.8s', animationFillMode: 'forwards' }}
          >
            <button
              onClick={() => scrollToSection('services')}
              className="btn-primary inline-flex items-center justify-center gap-2 group"
              data-testid="hero-cta-services"
            >
              {t('hero.cta')}
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="btn-outline inline-flex items-center justify-center gap-2"
              data-testid="hero-cta-contact"
            >
              <Play className="w-5 h-5" />
              {t('hero.ctaSecondary')}
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div 
          className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block"
          style={{ animationDelay: '1.5s' }}
        >
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center pt-2">
            <div className="w-1 h-3 bg-white/80 rounded-full animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};
